import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { Controller } from "react-hook-form";
import { Eye, EyeOff } from "lucide-react"; // Icons for toggling visibility
import { useState } from "react";

interface IInput {
  label?: string;
  name: string;
  type?: string;
  control: any;
  error?: string;
  maxLength?: number;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  column?: number;
  onBlur?: () => void;
  className?: string; // <-- Added custom className prop
}

export const JVPasswordInput = (props: IInput) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const isPasswordField = props.type === "password"; // Check if it's a password field

  // Determine a default column-based class name.
  const defaultColumnClass = props.column
    ? `field col-12 md:col-${12 / props.column}`
    : "field col-12 md:col-6";

  // Combine the default column class with any externally passed className.
  const containerClassName = `${defaultColumnClass} ${props.className || ""}`;

  return (
    <div className={containerClassName} style={{ position: "relative" }}>
      {props.label && (
        <label htmlFor={props.name} className="p-mb-1">
          {props.label}
          {props.required && <span style={{ color: "red" }}> *</span>}
        </label>
      )}

      <Controller
        name={props.name}
        control={props.control}
        render={({ field, fieldState }) => (
          <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
            <InputText
              {...field}
              maxLength={props.maxLength}
              onBlur={props.onBlur}
              disabled={props.disabled}
              placeholder={props.placeholder}
              type={isPasswordField && !isPasswordVisible ? "password" : "text"}
              className={classNames("p-inputtext p-component", {
                "p-invalid": fieldState.invalid,
              })}
              style={{ width: "100%", paddingRight: isPasswordField ? "2.5rem" : "1rem" }}
            />

            {isPasswordField && (
              <span
                onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                style={{
                  position: "absolute",
                  right: "10px",
                  cursor: "pointer",
                  color: "#666",
                }}
              >
                {isPasswordVisible ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            )}
          </div>
        )}
      />

      {props.error && <small className="p-error">{props.error}</small>}
    </div>
  );
};
